import dayjs from 'dayjs';
import { NavigationAuto } from 'entities/navigation';
import { Card } from 'store/features/user/types/state';

export const getMinFilterDate = () => dayjs().subtract(62, 'day').format();
export const getMaxFilterDate = () => dayjs().format();
export const buildObuNavigateOption = (item: NavigationAuto) => {
  const { autoNumber, obuNumber } = item;
  return {
    key: autoNumber,
    obuNumber,
    value: `${autoNumber} (OBU ${obuNumber})`,
  };
};
export const buildCardNavigateOption = (item: Card) => {
  const { autoNumber, cardNumber } = item;
  return {
    key: autoNumber,
    cardNumber,
    value: `${autoNumber} (Card ${cardNumber})`,
  };
};
